<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="10" vs-sm="4" vs-xs="12">
          <h3>Docs Template</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button v-if="abilities.can('create', 'campaigns')" icon="add" @click="addDocsTemplate" color="danger"
            type="border">Add</vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="12">
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <DataGrid :context="'DocsTemplate'" ref="DocsTemplates" :columnDefs="columnDefs" :rowData="records" :dataSource="dataSource">
      </DataGrid>
    </vx-card>
  </div>
</template>

<script>
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
export default {
  data: () => ({
    abilities: null,
    columnDefs: [
      {
        headerName: "Actions",
        field: "transactions",
        cellRenderer: "CellRendererActions",
        suppressHeaderMenuButton: true,
        pinned: true,
        width: 120
      },
      {
        headerName: "Name",
        field: "name",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        },
      },
      {
        headerName: "Description",
        field: "description",
        flex: 1,
        filter: "agTextColumnFilter",
        filterParams: {
          buttons: ["apply", "reset"],
          maxNumConditions: 4
        }
      },
      {
          headerName: "Template",
          field: "template_text",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Variables",
          field: "variables",
          flex: 1,
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
    ],
    dataSource: {},
    records: []
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignManagement,
    DataGrid
  },
  watch: {},
  methods: {
    addDocsTemplate() {
      this.$router.push({ path: `/campaign/create_docs_template` });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "campaignsManagement/getAllDocsTemplate",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.DocsTemplates.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.DocsTemplates.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    this.getDataSource();
  },
  mounted() { },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}

.ql-class {
  height: 400px;

}
</style>

<style lang="stylus">
.con-expand-Fields
  .con-btns-Fields
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Fieldsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
